import { useStoredPicksheet } from '~/domains/contest/domains/gamecenter/domains/common/hooks/useStoredPicksheet';
import { QuickPicksStoredPicksSchema } from '~/domains/contest/domains/quickPick/services/interfaces/quickPicks.schemas';

import type { PropPickProps } from '../../../../common/types/propPickProps.type';

function useStoredPicks() {
  return useStoredPicksheet<PropPickProps[]>({
    contestId: 'quickPicks',
    schema: QuickPicksStoredPicksSchema,
  });
}

export default useStoredPicks;
